import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./MyStyles.css";

function Menu(){

const userGroup = localStorage.getItem("userGroup");

const MenuCard = ({link,title,icon,color,external}) => (

<div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">

{external ? (

<a href={link} target="_blank" rel="noreferrer" className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</a>

) : (

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

)}

</div>

);

return(

<section className="menu-section container-fluid mt-4">

<div className="row">

{/* Dashboard */}
{userGroup === 'Admin' && (
<MenuCard link="/" title="Dashboard" icon="fa-solid fa-chart-line" color="#0d6efd"/>
)}

{/* Front Office */}
{userGroup === 'Admin' || userGroup === 'FrontOffice' ? (
<MenuCard link="/front-menu/" title="Front Office" icon="fa fa-h-square" color="#20c997"/>
) : null}

{/* Lab */}
{userGroup === 'Admin' || userGroup === 'Lab' ? (
<MenuCard link="/lab-menu/" title="LAB" icon="fa fa-flask-vial" color="#6f42c1"/>
) : null}

{/* Radiology */}
{userGroup === 'Admin' || userGroup === 'Radiology' ? (
<MenuCard link="/inv-menu/" title="Radiology" icon="fa-brands fa-square-odnoklassniki" color="#fd7e14"/>
) : null}

{/* Cashier */}
{userGroup === 'Admin' || userGroup === 'FrontOffice' || userGroup === 'Nurse' || userGroup === 'Cashier' ? (
<MenuCard link="/cash-menu/" title="Cashier" icon="fa fa-credit-card" color="#dc3545"/>
) : null}

{/* Inpatients */}
{userGroup === 'Admin' || userGroup === 'Cashier' || userGroup === 'FrontOffice' || userGroup === 'Ip' ? (
<MenuCard link="/ip-menu/" title="Inpatients" icon="fa-regular fa-hospital" color="#198754"/>
) : null}

{/* Nurse */}
{userGroup === 'Admin' || userGroup === 'Nurse' ? (
<MenuCard link="/nurse-menu/" title="Nurse" icon="fa fa-thermometer-3" color="#0dcaf0"/>
) : null}

{/* Consultant */}
{userGroup === 'Admin' || userGroup === 'Consultant' ? (
<>
<MenuCard link="/consult-menu/" title="Consultant" icon="fa fa-user-md" color="#6f42c1"/>



<MenuCard
link="https://drghis.mgmebuild.com/api/telemedicine/"
title="Tele-Medicine"
icon="fa-solid fa-laptop-medical"
color="#0d6efd"
external={true}
/>
</>
) : null}

{/* Pharmacy */}
{userGroup === 'Admin' || userGroup === 'Pharmacy' ? (
<MenuCard link="/pharm-menu/" title="Pharmacy" icon="fa-solid fa-prescription" color="#20c997"/>
) : null}

{/* Pharmacy Store */}
{userGroup === 'Admin' || userGroup === 'Cashier' || userGroup === 'PharmacyStore' ? (
<MenuCard link="/pharm-store/" title="Pharmacy - Store" icon="fa-solid fa-prescription-bottle-medical" color="#6610f2"/>
) : null}

{/* OT */}
{userGroup === 'Admin' || userGroup === 'Ot' ? (
<MenuCard link="/ot-menu/" title="Operation Theatre" icon="fa fa-scissors" color="#fd7e14"/>
) : null}

{/* EMR */}
{userGroup === 'Admin' || userGroup === 'Consultant' ? (
<MenuCard link="/pat-search/" title="EMR" icon="fa-solid fa-file-waveform" color="#0d6efd"/>
) : null}

{/* Accounting */}
{userGroup === 'Admin' || userGroup === 'Cashier' || userGroup === 'Accounting' ? (
<MenuCard link="/account-menu/" title="Accounting" icon="fa-solid fa-file-invoice-dollar" color="#dc3545"/>
) : null}

{/* HRMS */}
{userGroup === 'Admin'|| userGroup === 'Cashier' || userGroup === 'Hr' ? (
<MenuCard link="/hrms-menu/" title="HRMS" icon="fa-solid fa-people-line" color="#6c757d"/>
) : null}

{/* Stores */}
{userGroup === 'Admin' || userGroup === 'Cashier' || userGroup === 'Stores' ? (
<MenuCard link="/stores-menu/" title="Stores" icon="fa fa-truck" color="#7952b3"/>
) : null}

{/* Masters */}
{userGroup === 'Admin' || userGroup === 'FrontOffice' ? (
<MenuCard link="/master-menu/" title="Masters Setting" icon="fa fa-gears" color="#fd7e14"/>
) : null}

{/* MIS */}
{userGroup === 'Admin' || userGroup === 'Management' ? (
<>
<MenuCard link="/mis-menu/" title="MIS Dashboard" icon="fa fa-pie-chart" color="#20c997"/>
<MenuCard
  link="/pack-menu"
  title="Pack Menu"
  icon="fa fa-box-open"
  color="#198754"
/>
</>
) : null}

{/* Patient */}
{userGroup === 'Patient' ? (
<MenuCard link="/pat-menu/" title="Patient" icon="fa fa-user" color="#0dcaf0"/>
) : null}

{/* Blood Bank */}
{userGroup === 'Admin' || userGroup === 'BloodBank' ? (
<MenuCard link="/blood-bank/" title="Blood Bank" icon="fa fa-hand-holding-droplet" color="#dc3545"/>
) : null}

{/* CRM */}
{userGroup === 'Admin' || userGroup === 'Crm' ? (
<MenuCard link="/crm-menu/" title="CRM" icon="fa fa-id-badge" color="#6f42c1"/>
) : null}

{/* Messaging / Tools */}
{userGroup === 'Admin' || userGroup === 'Consultant' || userGroup === 'FrontOffice' || userGroup === 'Nurse' || userGroup === 'Lab' || userGroup === 'Radiology' || userGroup === 'Pharmacy' || userGroup === 'Pharmacy Store' || userGroup === 'Ip' || userGroup === 'Ot' || userGroup === 'Stores' || userGroup === 'Management' || userGroup === 'Cashier' || userGroup === 'Accounting' || userGroup === 'Crm' || userGroup === 'Blood Bank' ? (
<>
<MenuCard link="/comp-mess/" title="Messaging" icon="fa fa-comment-sms" color="#0d6efd"/>

<MenuCard link="/speech" title="Speech-Text" icon="fa fa-microphone" color="#d63384"/>

<MenuCard link="/events" title="Events List" icon="fa-regular fa-calendar-days" color="#20c997"/>

<MenuCard link="/todolist" title="ToDo Lists" icon="fa-solid fa-tasks" color="#fd7e14"/>

<MenuCard link="/ticket-menu/" title="Ticketing" icon="fa fa-ticket" color="#6f42c1"/>

<MenuCard link="/support/" title="MGM Support" icon="fa fa-wrench" color="#dc3545"/>
</>
) : null}

{/* News */}
{userGroup === 'Admin' ? (
<MenuCard link="/news/" title="News & Events" icon="fa-regular fa-newspaper" color="#fd7e14"/>
) : null}

{/* Barcode */}
{userGroup === 'Admin' || userGroup === 'FrontOffice' ? (
<MenuCard link="/barcode/" title="Generate Barcode" icon="fa fa-barcode" color="#20c997"/>
) : null}

</div>

</section>

)

}

export default Menu;